import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import { loginPageMessages } from '../../core-utils/messages/loginPageMessages';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import ResetPasswordOrganism from '../../_components/organisms/ResetPasswordOrganism';
import SvgIllustration from '../../_components/atoms/Icons/Illustration';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import componentConstants from '../../core-utils/messages/componentConstants';

const ResetPasswordPage = observer(() => {
  // styles
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      width: '1366',
      height: '100vh',
    },
    item1: {
      background:
        'linear-gradient(134.33deg, #475CB0 -5.57%, #656BC6 47.69%, #7477C8 68.03%, #A3A2D9 102.48%, #D5D3EB 141.44%, #FFFFFF 141.46%)',
      width: '670px',
      marginRight: '120px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    item2: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    text: {
      width: '393px',
      textAlign: 'center',
    },
  });

  const { classes } = useStyles();

  // constants
  const messages = loginPageMessages.LOGIN_PAGE;
  const constants = componentConstants.ORGANISMS.RESET_PASSWORD;

  // other
  const CryptoJS = require('crypto-js');
  const secret = process.env.ENCRYPTION_SECRET_KEY;

  // state variables
  const [loader] = useState<any>(<Loader />);
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<string>('');
  const [userData, setUserData] = useState<any>({
    userId: '',
    email: '',
    role: '',
    isForgotPassword: true,
    enabled: false,
    passwordReset: false,
  });
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  // functions
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const getUserDetails = async () => {
    setLoading(true);

    const queryParams = new URLSearchParams(window.location.search);
    let urlData;
    try {
      urlData = CryptoJS.AES.decrypt(
        decodeURIComponent(queryParams.get('a') ?? ''),
        secret,
      ).toString(CryptoJS.enc.Utf8);
    } catch (e) {
      handleOpenSnackBar('Invalid url', 'error', 8000);
    }

    try {
      const jsonUrlData = JSON.parse(urlData);
      setUserData({
        ...jsonUrlData,
        isForgotPassword: !jsonUrlData.isForgotPassword,
      });
    } catch (e) {
      handleOpenSnackBar('Invalid url parameters', 'error', 8000);
    }

    setLoading(false);
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <>
      {loading ? (
        loader
      ) : (
        <Grid container className={classes.root}>
          <Grid className={classes.item1}>
            <SvgIllustration height="234px" width="117px" />
            <Typography
              textColor={patientAccessTheme.palette.status.white}
              fontSize="28px"
              lineHeight="33.89px"
              fontType="semiBold"
              margin="97px 0px 21px 0px"
            >
              {messages.LINEAR_GRADIENT.LABEL1}
            </Typography>
            <Typography
              textColor={patientAccessTheme.palette.status.white}
              fontSize="16px"
              lineHeight="24px"
              fontType="regular"
              className={classes.text}
            >
              {messages.LINEAR_GRADIENT.LABEL2}
            </Typography>
          </Grid>
          <Grid
            className={classes.item2}
            style={{ marginTop: '28px', width: '40%' }}
          >
            {(!userData.enabled ||
              (!userData.isForgotPassword && userData.passwordReset)) && (
              <ResetPasswordOrganism
                setLoading={setLoading}
                userData={userData}
                isCreatePassword={userData.isForgotPassword}
                passwordError={passwordError}
                setPasswordError={setPasswordError}
              />
            )}
            {userData.enabled && userData.isForgotPassword && (
              <Typography
                textColor={patientAccessTheme.palette.text.highemphasis}
                fontSize="20px"
                lineHeight="30px"
                fontType="semiBold"
              >
                {constants.ALREADY_REGISTERED}
              </Typography>
            )}
            {userData.enabled &&
              !userData.isForgotPassword &&
              !userData.passwordReset && (
                <Typography
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontSize="20px"
                  lineHeight="30px"
                  fontType="semiBold"
                >
                  {constants.PASSWORD_RESET}
                </Typography>
              )}
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default ResetPasswordPage;
